import React from 'react';
import styled from 'styled-components/macro';
import { Container, Row, Col } from '../../components/grid';
import { Image } from '../../components/Image';
import {
  Heading1,
  Paragraph,
  Heading2,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { ScreenSizeDetector } from '../../lib/helpers';

const StyledParagraph = styled(Paragraph)`
  font-size: 16px;

  @media (max-width: 1199px) {
    font-size: inherit;
  }
`;

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="HoldbarhedFadoel">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1 textCenter>
            Holdbarhed på fadøl
          </Heading1>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} md={6} alignCenter alignSelfStart>
          <Heading2>Holdbarhed på åbnede fadølsfustager</Heading2>
          <StyledParagraph>
            Når fustagen er anbrudt er holdbarheden typisk 7 - 14 dage. Efterhånden som tiden går ændres smagen og der vil være en større tendens til at øllet skummer.
          </StyledParagraph>
          <StyledParagraph>
            Når fustagen er anbrudt må den ikke opbevares under 15 grader.
          </StyledParagraph>
          <StyledParagraph>
            Ovenstående gælder fadølsanlæg tilsluttet kulsyreflaske. Brug af kompressor reducerer holdbarheden markant.
          </StyledParagraph>
        </Col>
        <Col xs={12} md={6} textCenter uppercase>
          <ScreenSizeDetector imageHeight={[[767, '250px'], [991, '300px'], '400px']}>
            <Image name="fadoel.fustage-uden-plumbering.png" />
          </ScreenSizeDetector>
        </Col>
      </Row>
    </Container>
    <Container white>
      <ScreenSizeDetector direction={[[767, 'row'], 'row-reverse']}>
        <Row>
          <Col xs={12} md={6} alignCenter alignSelfStart>
            <Heading2>Holdbarhed på uåbnede fadølsfustager</Heading2>
            <StyledParagraph>
              Som på andre fødevarer er holdbarheden &quot;bedst før&quot; anført direkte på fustagen.
            </StyledParagraph>
            <StyledParagraph>
              Typisk er holdbarheden ca. 9 måneder fra tappedatoen. Hancock fustager har dog kun 2 måneder fra tappedatoen. Sædvanligvis smager øllet i fustagerne godt lang tid efter &quot;bedst før&quot; datoen, da øllet ligger mørkt og forseglet i fustagerne.
            </StyledParagraph>
          </Col>
          <Col xs={12} md={6} textCenter>
            <ScreenSizeDetector imageHeight={[[767, '250px'], [991, '300px'], '400px']}>
              <Image name="fadoel.fustage-med-plumbering.png" />
            </ScreenSizeDetector>
          </Col>
        </Row>
      </ScreenSizeDetector>
    </Container>
  </SidemenuLayout>
);
